<template>
    <div class="member-info">
        <a-descriptions class="app-region blank-t-v blank-b-v blank-l-h blank-r-h" title="基础信息" v-viewer bordered>
            <a-descriptions-item label="会员昵称">{{ info.nickname }}</a-descriptions-item>
            <a-descriptions-item label="姓名">{{ info.name }}</a-descriptions-item>
            <a-descriptions-item label="手机号">{{ info.name }}</a-descriptions-item>
            <a-descriptions-item label="姓名">{{ info.mobile }}</a-descriptions-item>
            <a-descriptions-item label="性别">{{ info.sexText }}</a-descriptions-item>
            <a-descriptions-item label="出生日期">{{ info.birthday }}</a-descriptions-item>
            <a-descriptions-item label="证件号码">{{ info.id_card }}</a-descriptions-item>
            <a-descriptions-item label="邮箱">{{ info.email }}</a-descriptions-item>
            <a-descriptions-item label="学历">{{ info.extends.education }}</a-descriptions-item>
            <a-descriptions-item label="职业">{{ info.extends.professional }}</a-descriptions-item>
            <a-descriptions-item label="身高">{{ info.extends.height }}</a-descriptions-item>
            <a-descriptions-item label="情感状态">{{ info.extends.marriage }}</a-descriptions-item>
            <a-descriptions-item label="注册时间">{{ info.created_at }}</a-descriptions-item>
            <a-descriptions-item label="用户头像">
                <dy-image :src="info.head_image"></dy-image>
            </a-descriptions-item>
            <a-descriptions-item label="人脸照片">
                <dy-image :src="info.face_recognition"></dy-image>
            </a-descriptions-item>
        </a-descriptions>
        <div class="app-region blank-b-v blank-l-h blank-r-h">
            <div class="page-title">社区信息</div>
            <a-table :loading="tableOne.loading" :columns="tableOne.columns" :data-source="tableOne.data" rowKey="id"
                :pagination="false"></a-table>
        </div>
        <!-- <div class="app-region blank-b-v blank-l-h blank-r-h">
        <div class="page-title">车辆信息</div>
        <a-table :loading="tableTwo.loading" :columns="tableTwo.columns" :data-source="tableTwo.data" rowKey="id">
        </a-table>
      </div> -->
    </div>
</template>
  
<script>
import MemberService from '@/io/member.js';
import {
    sexText,
    houseCertificateStatusText
} from '@/io/dict.js';

export default {
    name: 'MemberInfo',
    data() {
        let self = this;
        return {
            id: this.$route.params.id,
            info: {
                extends: {}
            },
            tableOne: {
                loading: false,
                page: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    }
                },
                data: [],
                columns: [
                    {
                        title: '社区名称',
                        dataIndex: 'owner_community.name'
                    },
                    {
                        title: '房屋信息',
                        dataIndex: 'owner_housing_only.full_name'
                    },
                    {
                        title: '房屋身份',
                        dataIndex: 'owner_identity.name'
                    },
                    {
                        title: '房屋认证状态',
                        dataIndex: 'houseCertificateStatusText'
                    }
                ]
            },
            tableTwo: {
                loading: false,
                page: {
                    total: 0,
                    current: 1,
                    pageSize: 10,
                    showQuickJumper: true,
                    showSizeChanger: true,
                    showTotal() {
                        return `共${self.table.page.total}条`;
                    }
                },
                data: [],
                columns: [
                    {
                        title: '车牌号码',
                        dataIndex: 'car_number'
                    },
                    {
                        title: '绑定时间',
                        dataIndex: 'created_at'
                    },
                    {
                        title: '车辆行驶证',
                        scopedSlots: { customRender: 'action' },
                    }
                ]
            }
        }
    },
    mounted() {
        this.initInfo();
    },
    methods: {
        initInfo() {
            MemberService.info(this.id).then(res => {
                this.info = {
                    ...res,
                    sexText: sexText(res.sex)
                };
                this.tableOne.data = res.housing.map(val => {
                    val.houseCertificateStatusText = houseCertificateStatusText(val.audit_type);
                    return val;
                });
                // 暂时去掉
                // this.tableTwo.data = res.car_info;
            }).catch(err => { });
        }
    },
}
</script>
  
<style lang="less" scoped></style>